/* eslint-disable no-array-constructor */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
import React from "react";
import { v4 } from "uuid";
import { routers } from "../Constants/routers";
import Api from "../Server/Api";
import { noAvatar } from "./Functions";


export const getAreaName = (location) => {
	try {
		if (!location) return "";
		if (location?.address_component) {
			const components = location.address_component || [];
			let sublocality_level_1 = components.find((e) =>
				e.types.includes("sublocality_level_1"),
			);
			if (sublocality_level_1)
				return sublocality_level_1?.long_name || sublocality_level_1?.short_name;
			let sublocality = components.find((e) =>
				e.types.includes("sublocality"),
			);
			if (sublocality)
				return sublocality?.long_name || sublocality?.short_name;
			let neighborhood = components.find((e) =>
				e.types.includes("neighborhood"),
			);
			if (neighborhood)
				return neighborhood?.long_name || neighborhood?.short_name;
			let locality = components.find((e) => e.types.includes("locality"));
			if (locality) return locality?.long_name || locality?.short_name;
			let administrative_area_level_2 = components.find((e) =>
				e.types.includes("administrative_area_level_2"),
			);
			if (administrative_area_level_2)
				return (
					administrative_area_level_2?.long_name ||
					administrative_area_level_2?.short_name
				);
		}
		let d = location?.address?.split(",");
		return (d?.length >= 2 ? d[1] : d[0]).replace(/[0-9]/g, "").trim();
	} catch (error) {
		if (typeof location === "string") return location;
	}
};

const PopOverImage = ({ image, imgClass, children, data, type }) => {
	const element = v4();
	const initPopover = () => {
		$("." + element).each(async function () {
            if(!data) return;
			var a = $(this),
				n = $(this).attr("data-user-popover"),
				s = feather.icons.mail.toSvg(),
				i = feather.icons.phone.toSvg(),
				o = feather.icons["message-circle"].toSvg();

			const e =  data;// await api.get({ endpoint: datasource });
			a.webuiPopover({
				trigger: "hover",
				placement: "auto",
				width: 300,
				padding: !1,
				offsetLeft: 0,
				offsetTop: 20,
				animation: "pop",
				style: "profile",
				cache: !1,
				content: function () {
					if (
						(setTimeout(function () {
							$(".loader-overlay").removeClass("is-active");
						}, 500),
						e?.id > 0)
					)
						var a =
							'\n <div class="profile-popover-block '+type+' ">\n\n     <div class="loader-overlay is-active">\n <div class="loader is-loading"></div>\n     </div>\n\n     <div class="profile-popover-wrapper">\n <div class="popover-avatar">\n     '+
                            '<img class="avatar '+imgClass+' " src="' + (e.image || noAvatar()) +'"/>'+
                            '</div>\n <div class="popover-meta">\n     <span class="user-meta">\n <span class="username">' +
							e.name +
							'</span>\n <span class="location">' +
							getAreaName(e.location) +
							'</span>\n     </span>\n     <span class="job-title">' +
							e.role +
							'</span>\n     <span class="bio">' +
							e?.header_title +
							'</span>\n </div>\n     </div>\n     <div class="popover-actions">\n  <a class="button h-button is-primary w-100" href="'+routers.pages.doctor(e?.username)+'">\n     ' +
							"\n Book Appointment Now </a>\n     </div>\n </div>\n";

					// else {
					// 	var t = new Array(
					// 			"is-danger",
					// 			"is-info",
					// 			"is-primary",
					// 			"is-success",
					// 			"is-warning",
					// 			"is-h-purple",
					// 			"is-h-blue",
					// 			"is-h-green",
					// 			"is-h-orange",
					// 			"is-h-red",
					// 			"is-h-green",
					// 		),
					// 		p = t.length;
					// 	a =
					// 		'\n\n <div class="profile-popover-block">\n\n     <div class="loader-overlay is-active">\n <div class="loader is-loading"></div>\n     </div>\n\n     <div class="profile-popover-wrapper">\n <div class="popover-fake-avatar ' +
					// 		t[Math.floor(Math.random() * p)] +
					// 		'">\n     <div class="fake-avatar">\n <span>' +
					// 		e.initials +
					// 		'</span>\n     </div>\n     <img class="badge" src="' +
					// 		e.badge +
					// 		'">\n </div>\n <div class="popover-meta">\n     <span class="user-meta">\n <span class="username">' +
					// 		e.name +
					// 		'</span>\n <span class="location">' +
					// 		getAreaName(e.location) +
					// 		'</span>\n     </span>\n     <span class="job-title">' +
					// 		e.position +
					// 		'</span>\n     <span class="bio">' +
					// 		e.bio +
					// 		'</span>\n </div>\n     </div>\n     <div class="popover-actions">\n <a class="popover-icon">\n     ' +
					// 		i +
					// 		'\n </a>\n <a class="popover-icon">\n     ' +
					// 		s +
					// 		'\n </a>\n <a class="popover-icon">\n     ' +
					// 		o +
					// 		"\n </a>\n     </div>\n\n </div>\n";
					// }
					return a;
				},
			});
		});
	};

	React.useEffect(() => {
		initPopover();
	}, []);

	return (
		<>
			<div className={"h-avatar " + element}>
				<img
					className={"avatar "+imgClass}
					src={image || noAvatar()}
					alt=""
					data-user-popover={0}
				/>
			</div>
			{children}
		</>
	);
};

export default PopOverImage;
